<template>
    <div v-if="!showContactForm" class="row py-md-4">
        <div class="col-12">
            <p class="card-text">
                {{
                    $t('bookingService.mode.text')
                }}
            </p>
        </div>

        <div class="col-12 text-center pt-3">
            <button @click="showContactForm = true" class="btn btn-primary text-nowrap">
                {{
                    $t('bookingService.mode.button.send')
                }}
            </button>
        </div>

        <div class="col-12 text-center pt-3">
            <button class="btn btn-primary text-nowrap" @click="proceedToReservation">
                {{
                    $t('bookingService.mode.button.proceed')
                }}
            </button>
        </div>
        <div class="col-12 pt-3">
            <external-incentive-block v-if="hasBonus" :code="$store.getters.voucherCode"/>
        </div>
    </div>

    <div v-else>
        <ContactForm v-if="!dataIsSent" @submit="contactSubmit" :is-sending="isSendingData"
                     :showNewsletterCheckbox="true"  :sendVoucher="true">
        </ContactForm>

        <div v-else>
            <h1 class="card-title h5">{{ $t('common.dear_guest') }}</h1>
            <p class="card-text">
                {{ $t('bookingServiceSuccess.supporting_text.common.success_message.text') }}
            </p>
            <p class="card-text">
                {{
                    $t('bookingService.mode.success.text')
                }}
            </p>
            <i18n path="bookingServiceSuccess.supporting_text.common.customer_support.text" tag="p"
                  class="card-text text-secondary">
                <CustomerServiceEmail/>
                <CustomerServicePhone/>
            </i18n>
            <div class="card-navigation">
                <button class="btn btn-secondary" @click="$store.dispatch('reset')">
                    {{ $t('common.redeem_another_voucher') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ContactForm from '@/components/ContactForm'
import CustomerServiceEmail from '../components/CustomerServiceEmail'
import CustomerServicePhone from '../components/CustomerServicePhone'
import ExternalIncentiveBlock from '../components/ExternalIncentiveBlock'

export default {
    name: 'BookableHotelVoucherMode',
    components: { ContactForm, CustomerServiceEmail, CustomerServicePhone, ExternalIncentiveBlock },
    data () {
        return {
            showContactForm: false,
            isSendingData: false,
            dataIsSent: false
        }
    },
    props: {},
    computed: {
        hasBonus() {
            return this.$store.state.voucher.eligibleForExternalIncentive
        }
    },
    methods: {
        async contactSubmit (contactData) {
            this.isSendingData = true
            try {
                const voucherCode = this.$store.getters.voucherCode;
                const response = await this.$store.dispatch('sendContactForm', {
                    ...contactData,
                    voucherCode,
                    sendVoucher: true
                })
                this.dataIsSent = true
            } finally {
                this.isSendingData = false
            }
        },
        proceedToReservation () {
            this.$emit('proceed')
        }
    }
}
</script>

<style scoped lang="scss">

</style>
